import { createStore as reduxCreateStore, combineReducers, applyMiddleware } from 'redux'
import { createLogger } from 'redux-logger'
import thunk from 'redux-thunk'
import { History } from 'history'
import { connectRouter, routerMiddleware } from 'connected-react-router'
// Reducers
import { AuthReducer } from 'reducks/auth/reducers'
import { BasketReducer } from 'reducks/basket/reducers'
import { BrandReducer } from 'reducks/brand/reducers'
import { BreadReducer } from 'reducks/bread/reducers'
import { CalendarReducer } from 'reducks/calendar/reducers'
import { CampaignReducer } from 'reducks/campaign/reducers'
import { CategoryReducer } from 'reducks/category/reducers'
import { CheckoutReducer } from 'reducks/checkout/reducers'
import { CouponReducer } from 'reducks/coupon/reducers'
import { ErrorReducer } from 'reducks/error/reducers'
import { LoadingReducer } from 'reducks/loading/reducers'
import { ManufacturerReducer } from 'reducks/manufacturer/reducers'
import { ModalReducer } from 'reducks/modal/reducers'
import { NavReducer } from 'reducks/nav/reducers'
import { ScheduleReducer } from 'reducks/schedule/reducers'
import { ConfirmReducer } from 'reducks/confirm/reducers'
import { PointCardReducer } from 'reducks/pointCard/reducers'
import { PushMessageReducer } from 'reducks/pushMessage/reducers'
import { ShopReducer } from 'reducks/shop/reducers'
import { ShopSubscriptionReducer } from 'reducks/shopSubscription/reducers'
import { StaffReducer } from 'reducks/staff/reducers'
import { StockReducer } from 'reducks/stock/reducers'
import { StoreReducer } from 'reducks/store/reducers'
import { StoreCalendarReducer } from 'reducks/storeCalendar/reducers'
import { StoreDeliveryBreadReducer } from 'reducks/storeDeliveryBread/reducers'
import { StoreDeliveryFeeReducer } from 'reducks/storeDeliveryFee/reducers'
import { StoreDeliverySettingReducer } from 'reducks/storeDeliverySetting/reducers'
import { StoreShippingReducer } from 'reducks/storeShipping/reducers'
import { StoreTimesaleReducer } from 'reducks/storeTimesale/reducers'
import { TagReducer } from 'reducks/tag/reducers'
import { UserReducer } from 'reducks/user/reducers'

// createStoreの再定義 - historyを引数で受け、connected-react-routerの利用を抽象化
export default function createStore(history: History<unknown>) {
  // historyとredux-thunkをミドルウェアに追加
  const middleWares = [routerMiddleware(history), thunk]

  // 開発環境の場合、redux-loggerを設定
  if (process.env.NODE_ENV === 'development') {
    const logger = createLogger({
      collapsed: true, // 折り畳まれた状態で表示
      // diff: true, // 変更前後の差分を表示
    })
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    middleWares.push(logger as any)
  }

  // 別名importしたcreateStoreメソッドにReducersとミドルウェアを渡す
  return reduxCreateStore(
    combineReducers({
      auth: AuthReducer,
      basket: BasketReducer,
      brand: BrandReducer,
      bread: BreadReducer,
      calendar: CalendarReducer,
      campaign: CampaignReducer,
      category: CategoryReducer,
      checkout: CheckoutReducer,
      confirm: ConfirmReducer,
      coupon: CouponReducer,
      error: ErrorReducer,
      loading: LoadingReducer,
      manufacturer: ManufacturerReducer,
      modal: ModalReducer,
      nav: NavReducer,
      pointCard: PointCardReducer,
      pushMessage: PushMessageReducer,
      router: connectRouter(history),
      schedule: ScheduleReducer,
      shop: ShopReducer,
      shopSubscription: ShopSubscriptionReducer,
      staff: StaffReducer,
      stock: StockReducer,
      store: StoreReducer,
      storeCalendar: StoreCalendarReducer,
      storeDeliveryBread: StoreDeliveryBreadReducer,
      storeDeliveryFee: StoreDeliveryFeeReducer,
      storeDeliverySetting: StoreDeliverySettingReducer,
      storeShipping: StoreShippingReducer,
      storeTimesale: StoreTimesaleReducer,
      tag: TagReducer,
      user: UserReducer,
    }),
    applyMiddleware(...middleWares)
  )
}
